export default {
  // any array should have unique values as the values are used as keys
  // months
  formattedShortMonths: [
    'ม.ค.',
    'ก.พ.',
    'มี.ค.',
    'เม.ย.',
    'พ.ค.',
    'มิ.ย.',
    'ก.ค.',
    'ส.ค.',
    'ก.ย.',
    'ต.ค.',
    'พ.ย.',
    'ธ.ค.',
  ],
  months: [
    'มกราคม',
    'กุมภาพันธ์',
    'มีนาคม',
    'เมษายน',
    'พฤษภาคม',
    'มิถุนายน',
    'กรกฎาคม',
    'สิงหาคม',
    'กันยายน',
    'ตุลาคม',
    'พฤศจิกายน',
    'ธันวาคม',
  ],
  months_calendar: {
    January: 'มกราคม',
    February: 'กุมภาพันธ์',
    March: 'มีนาคม',
    April: 'เมษายน',
    May: 'พฤษภาคม',
    June: 'มิถุนายน',
    July: 'กรกฎาคม',
    August: 'สิงหาคม',
    September: 'กันยายน',
    October: 'ตุลาคม',
    November: 'พฤศจิกายน',
    December: 'ธันวาคม',
  },
  // weekdays
  weekdays: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
  weekdays_booking_container: {
    Sunday: 'วันอาทิตย์',
    Monday: 'วันจันทร์',
    Tuesday: 'วันอังคาร',
    Wednesday: 'วันพุธ',
    Thursday: 'วันพฤหัสบดี',
    Friday: 'วันศุกร์',
    Saturday: 'วันเสาร์',
  },
  weekdays_calendar: {
    Sun: 'อาทิตย์',
    Mon: 'จันทร์',
    Tue: 'อังคาร',
    Wed: 'พุธ',
    Thu: 'พฤหัสบดี',
    Fri: 'ศุกร์',
    Sat: 'เสาร์',
  },
  // additional translations
  today: 'วันนี้',
  tomorrow: 'พรุ่งนี้',
};
